import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * 404 界面
 * @user: antes
 * @emial: tangzhlyd@gmail.com
 * @data: 2020/12/8 下午3:39
 */ import { Button } from "antd";
import $style from "@/components/Loading/index.css";
import { useNavigate } from "react-router-dom";
export const NotFound = ()=>{
    const navigate = useNavigate();
    function goHome() {
        navigate("/");
    }
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: $style.page404,
                children: "404"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: $style.subtitle,
                children: "很抱歉，您访问的页面不存在。"
            }),
            /*#__PURE__*/ _jsx("div", {
                style: {
                    textAlign: "center"
                },
                children: /*#__PURE__*/ _jsx(Button, {
                    type: "link",
                    onClick: goHome,
                    children: "Go Home"
                })
            })
        ]
    });
};
